import "particles.js";
import $ from "jquery";
import { debounce } from './Helpers/debounce';

/**
 * See (https://github.com/VincentGarreau/particles.js/)
 */

export class ParticlesModule {

    constructor() {
        if (!$('#particles').length) {
            return;
        }

        this.currentWindowWidth = window.innerWidth;
        
        this.conf = this.setParticlesConf();
        this.initParticles();

        $(window).on('resize', debounce(() => {
                if (window.innerWidth != this.currentWindowWidth) {
                    this.currentWindowWidth = window.innerWidth;
                    this.initParticles();
                }
            }, 150) 
        );
            
    }

    initParticles() {
        this.setParticleCount();
        particlesJS('particles', this.conf);
    }

    destroyParticles() {
        window.pJSDom[0].pJS.fn.vendors.destroypJS();
        window["pJSDom"] = [];
    }

    setParticleCount() {
        const vw = window.innerWidth;
        this.conf.particles.number.value = 30;
         
        if (vw < 1025) {
            this.conf.particles.number.value = 25;
        } 
        if (vw < 800) {
            this.conf.particles.number.value = 20;
        }
       // console.log(this.conf.particles.number.value);
    }

    setParticlesConf() {
        return {
            "particles": {
              "number": {
                "value": 20,
                "density": {
                  "enable": true,
                  "value_area": 700.2163090910595
                }
              },
              "color": {
                "value": "#005780"
              },
              "shape": {
                "type": "circle",
                "stroke": {
                  "width": 2,
                  "color": "#005780"
                },
                "polygon": {
                  "nb_sides": 7
                },
                "image": {
                  "src": "img/github.svg",
                  "width": 100,
                  "height": 100
                }
              },
              "opacity": {
                "value": 1,
                "random": false,
                "anim": {
                  "enable": false,
                  "speed": 1,
                  "opacity_min": 0.1,
                  "sync": false
                }
              },
              "size": {
                "value": 3,
                "random": true,
                "anim": {
                  "enable": false,
                  "speed": 40,
                  "size_min": 0.1,
                  "sync": false
                }
              },
              "line_linked": {
                "enable": true,
                "distance": 400,
                "color": "#00c6ff",
                "opacity": 0.35,
                "width": 1
              },
              "move": {
                "enable": true,
                "speed": 1,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "bounce",
                "bounce": false,
                "attract": {
                  "enable": false,
                  "rotateX": 600,
                  "rotateY": 1200
                }
              }
            },
            "interactivity": {
              "detect_on": "canvas",
              "events": {
                "onhover": {
                  "enable": false,
                  "mode": "repulse"
                },
                "onclick": {
                  "enable": false,
                  "mode": "push"
                },
                "resize": false
              },
              "modes": {
                "grab": {
                  "distance": 400,
                  "line_linked": {
                    "opacity": 1
                  }
                },
                "bubble": {
                  "distance": 400,
                  "size": 40,
                  "duration": 2,
                  "opacity": 8,
                  "speed": 3
                },
                "repulse": {
                  "distance": 200,
                  "duration": 0.4
                },
                "push": {
                  "particles_nb": 4
                },
                "remove": {
                  "particles_nb": 2
                }
              }
            },
            "retina_detect": true
          }
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/ParticlesModule.js